import React from "react";
import bgImage from "../../../assets/overview_img/integration/maroon-bg.jpg";

function FormSection() {
  return (
    <section
      className="
        relative
        overflow-hidden

        min-h-screen

        bg-cover
        bg-center
        bg-no-repeat

        px-4
        sm:px-6
        lg:px-10

        py-10
        lg:py-20
      "
     style={{
    backgroundImage: `url(${bgImage})`,
  }}
    >
      {/* DARK OVERLAY */}
      <div
        className="
          absolute
          inset-0
          bg-gradient-to-r
          from-[#2b0000]/95
          via-[#4b0000]/85
          to-[#c64213]/70
        "
      />

      {/* CONTENT */}
      <div
        className="
          relative
          z-10

          max-w-[1350px]
          mx-auto

          grid
          grid-cols-1
          md:grid-cols-2
          lg:grid-cols-2
          gap-10
          md:gap-16
          lg:gap-20
          items-start
          lg:ml-[70px]
        "
      >
        {/* LEFT CONTENT */}
        <div className="text-white pt-4 lg:pt-10">
          <h2
            className="
            lg:mt-[10px]
              font-serif
              font-light

              text-[30px]
              md:text-[30px]
              leading-[38px]

              sm:text-[54px]
              sm:leading-[58px]

              lg:text-[42px]
              lg:leading-[42px]

              max-w-[600px]
            "
          >
            Elevate your business
            <br />

          <span
  className="
    font-black
    font-sans

    text-[50px]
    leading-[54px]
    md:text-[50px]
    md:leading-[54px]

    sm:text-[82px]
    sm:leading-[78px]

    lg:text-[50px]
    lg:leading-[64px]

    block
    mt-2
  "
>
  with On-
  Demand Pay
</span>
          </h2>

          <p
            className="
              mt-6

              text-[16px]
              sm:text-[18px]
              lg:text-[18px]

              font-sans
            "
          >
            Schedule your personalized demo today.
          </p>
        </div>

        {/* FORM CARD */}
        <div
          className="
            bg-white

            rounded-[8px]
            sm:rounded-[10px]

            shadow-2xl

            p-5
            sm:p-7
            lg:p-8
            w-full
            max-w-[520px]
            md:max-w-[500px]

            lg:max-w-[650px]
            mx-auto
            lg:ml-auto
            md:mt-[60px]
          "
        >
          <form className="space-y-5">
            {/* NAME ROW */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label
                  className="
                    text-[13px]
                    font-serif
                    mb-0
                    text-black
                    block
                  "
                >
                  First Name <span className="text-red-600">*</span>
                </label>

                <input
                  type="text"
                  className="
                    w-full
                    h-[42px]

                    border
                    border-gray-300

                    px-3

                    outline-none
                    focus:border-black
                  "
                />
              </div>

              <div>
                <label
                  className="
                    text-[13px]
                    font-serif
                    mb-0
                    text-black
                    block
                  "
                >
                  Last Name <span className="text-red-600">*</span>
                </label>

                <input
                  type="text"
                  className="
                    w-full
                    h-[42px]

                    border
                    border-gray-300

                    px-3

                    outline-none
                    focus:border-black
                  "
                />
              </div>
            </div>

            {/* SELECT */}
            <div>
              <label
                className="
                  text-[12px]
                  font-semibold
                  text-black
                  block
                  mb-2
                "
              >
                Department <span className="text-red-600">*</span>
              </label>

              <select
                className="
                  w-full
                  h-[44px]

                  border
                  border-gray-300

                  px-3

                  text-[14px]

                  outline-none
                  focus:border-black
                  bg-white
                "
              >
                <option>Select...</option>
                <option>HR</option>
                <option>Finance</option>
                <option>Operations</option>
              </select>
            </div>

            {/* INPUTS */}
            {[
              "Work Email",
              "Phone Number",
              "Company Name",
              "Number of Employees",
            ].map((field, index) => (
              <div key={index}>
                <label
                  className="
                    text-[12px]
                    font-semibold
                    text-black
                    block
                    mb-2
                  "
                >
                  {field} <span className="text-red-600">*</span>
                </label>

                <input
                  type="text"
                  className="
                    w-full
                    h-[42px]

                    border
                    border-gray-300

                    px-3

                    outline-none
                    focus:border-black
                  "
                />
              </div>
            ))}

            {/* TEXTAREA */}
            <div>
              <label
                className="
                  text-[12px]
                  font-semibold
                  text-black
                  block
                  mb-2
                "
              >
                How can we help?
              </label>

              <textarea
                rows="4"
                className="
                  w-full

                  border
                  border-gray-300

                  px-3
                  py-3

                  resize-none

                  outline-none
                  focus:border-black
                "
              />
            </div>

            {/* BUTTON */}
            <button
              type="submit"
              className="
                bg-[#4b0000]
                text-white

                px-8
                py-3

                text-[15px]
                font-semibold

                hover:bg-[#6d0000]

                transition-all
                duration-300
              "
            >
              Submit
            </button>

            <p
              className="
                text-[10px]
                text-gray-500
                italic
                pt-2
              "
            >
              This site is protected by reCAPTCHA.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}

export default FormSection;